import React, { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useReduxSelector } from "@hooks/useReduxSelector";
import { AdditionalInformationService } from "@services/all.services";
import { setAdditionalInformation } from "@store/actions/settings/additionalInformationActions";
import { useDispatch } from "react-redux";
import { hasDuplicateAttribute } from "@helpers/_functions";
import { useNotification } from "@hooks/useNotification";
import EmptyData from "@components/tailwindComponents/EmptyData";
import InformationItem from "./InformationItem";
import { useUserPermission } from "@hooks/users";

function SectionAdditionalInfo({ fieldNamePrefix, readOnly = false, hideAddButton = false, isEnterprisePage = false }) {
  const { control } = useFormContext();
  const { t: translator } = useTranslation("settings.additionalInfo");
  const additionalInformation = useReduxSelector(({ settings }) => settings?.additionalInformation);
  const dispatch = useDispatch();
  const { showError } = useNotification();
  const { canAccessAdditionalInformation } = useUserPermission();

  const readOnlyAccess = useMemo(() => {
    return isEnterprisePage ? readOnly : !canAccessAdditionalInformation;
  }, [readOnly, isEnterprisePage, canAccessAdditionalInformation])

  const updateProcess = (dataToSave) => {
    AdditionalInformationService.updateById(dataToSave);
    dispatch(setAdditionalInformation({
      list: additionalInformation?.list?.map((item) => item._id === dataToSave._id ? dataToSave : item),
      isLoaded: true
    }));
  }

  const addItem = (data, index) => {
    const dataToSave = {
      ...additionalInformation?.list?.[index],
      infosList: [...additionalInformation?.list?.[index]?.infosList, { _id: data.name, name: data.name }]
    }
    if (hasDuplicateAttribute(dataToSave.infosList, "name")) {
      showError("already_exists", { object: "TheTitle" });
    } else {
      updateProcess(dataToSave);
    }
  }

  const editItem = (data, index) => {
    const dataToSave = {
      ...additionalInformation?.list?.[index],
      infosList: additionalInformation?.list?.[index]?.infosList?.map((item) => item._id === data._id ? { _id: data.name, name: data.name } : item)
    }
    if (hasDuplicateAttribute(dataToSave.infosList, "name")) {
      showError("already_exists", { object: "TheTitle" });
    } else {
      updateProcess(dataToSave);
    }
  }

  const deleteItem = (data, index) => {
    const dataToSave = {
      ...additionalInformation?.list?.[index],
      infosList: additionalInformation?.list?.[index]?.infosList?.filter((item) => item._id !== data._id)
    }
    updateProcess(dataToSave);
  }

  return (
    additionalInformation?.list?.length === 0 ?
      <div
        className="arh-w-full arh-pb-8"
      >
        <EmptyData>
          {translator("Aucune information complémentaires à afficher")}
        </EmptyData>
      </div>
      :
      <div className="arh-grid arh-grid-cols-4 arh-gap-4 arh-mx-8 arh-my-2 tablet-850:!arh-grid-cols-2 tablet-850:!arh-ml-[2.5rem] tablet-850:!arh-mr-[1rem]">
        {
          additionalInformation?.list?.map((item, index) => (
            <div
              className="arh-w-full arh-pb-8"
              key={item._id}
            >
              <InformationItem
                item={item}
                index={index}
                control={control}
                fieldNamePrefix={fieldNamePrefix}
                readOnly={readOnlyAccess}
                addItem={addItem}
                deleteItem={deleteItem}
                editItem={editItem}
                translator={translator}
                hideAddButton={hideAddButton}
              />
            </div>
          ))
        }

      </div>
  )
}

export default SectionAdditionalInfo;
